/* ============================================================
   HAPPY THAI HATS — Shopify theme JS
   AJAX cart drawer, toasts, confetti, reveal-on-scroll
   ============================================================ */

(function () {
  'use strict';

  /* ---------- money ---------- */
  function formatMoney(cents) {
    const fmt = (window.themeSettings && window.themeSettings.moneyFormat) || '${{amount}}';
    const amount = (cents / 100).toFixed(2).replace(/\.00$/, '');
    return fmt.replace(/\{\{\s*amount[^}]*\}\}/, amount).replace(/<[^>]+>/g, '');
  }
  window.formatMoney = formatMoney;

  /* ---------- toast ---------- */
  let toastTimer;
  window.toast = function (msg) {
    const t = document.getElementById('toast');
    if (!t) return;
    t.textContent = msg;
    t.classList.add('show');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(() => t.classList.remove('show'), 2600);
  };

  /* ---------- confetti ---------- */
  window.confettiBurst = function () {
    const colors = ['#EC4899', '#FACC15', '#84CC16', '#38BDF8', '#F97316', '#6D28D9'];
    for (let i = 0; i < 26; i++) {
      const b = document.createElement('div');
      const size = 6 + Math.random() * 8;
      b.style.cssText = 'position:fixed;z-index:600;left:50%;top:40%;width:' + size + 'px;height:' + size * 0.6 + 'px;background:' + colors[i % colors.length] + ';border-radius:2px;pointer-events:none;';
      document.body.appendChild(b);
      const ang = Math.random() * Math.PI * 2, v = 120 + Math.random() * 220;
      b.animate([
        { transform: 'translate(0,0) rotate(0)', opacity: 1 },
        { transform: 'translate(' + Math.cos(ang) * v + 'px,' + (Math.sin(ang) * v + 260) + 'px) rotate(' + (Math.random() * 720 - 360) + 'deg)', opacity: 0 }
      ], { duration: 900 + Math.random() * 700, easing: 'cubic-bezier(.17,.67,.35,1)' }).onfinish = () => b.remove();
    }
  };

  /* ---------- cart drawer ---------- */
  const CartDrawer = {
    el: null, overlay: null,
    init() {
      this.el = document.getElementById('cartDrawer');
      this.overlay = document.getElementById('cartOverlay');
      if (!this.el) return;
      this.overlay.addEventListener('click', () => this.close());
      document.querySelectorAll('[data-cart-open]').forEach(b =>
        b.addEventListener('click', e => { e.preventDefault(); this.open(); }));
      this.el.querySelector('[data-cart-close]').addEventListener('click', () => this.close());
      this.refresh();
    },
    open() { this.el.classList.add('open'); this.overlay.classList.add('open'); },
    close() { this.el.classList.remove('open'); this.overlay.classList.remove('open'); },
    async refresh() {
      const res = await fetch(window.themeSettings.cartUrl + '.js');
      const cart = await res.json();
      this.render(cart);
    },
    render(cart) {
      document.querySelectorAll('[data-cart-count]').forEach(el => el.textContent = cart.item_count);
      const wrap = this.el.querySelector('[data-cart-items]');
      const totalEl = this.el.querySelector('[data-cart-total]');
      totalEl.textContent = formatMoney(cart.total_price);
      if (!cart.items.length) {
        wrap.innerHTML = '<div class="cart-empty"><div class="big">🎪</div><p><strong>Your cart is feeling shy.</strong><br>Add a hat and start a party.</p></div>';
        return;
      }
      wrap.innerHTML = cart.items.map(item => `
        <div class="cart-item">
          <div class="thumb">${item.image ? '<img src="' + item.image.replace(/(\.[a-z]+)(\?|$)/, '_160x$1$2') + '" alt="" loading="lazy">' : ''}</div>
          <div><h4>${item.product_title}</h4>
            ${item.variant_title && item.variant_title !== 'Default Title' ? '<p style="font-size:.82rem;color:var(--ink-soft)">' + item.variant_title + '</p>' : ''}
            <div class="qty">
              <button aria-label="Decrease quantity" data-qty-change="${item.key}" data-qty="${item.quantity - 1}">−</button>
              <span>${item.quantity}</span>
              <button aria-label="Increase quantity" data-qty-change="${item.key}" data-qty="${item.quantity + 1}">+</button>
            </div>
          </div>
          <div class="line-price">${formatMoney(item.final_line_price)}</div>
        </div>`).join('');
      wrap.querySelectorAll('[data-qty-change]').forEach(btn => {
        btn.addEventListener('click', async () => {
          await fetch(window.themeSettings.cartChangeUrl + '.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ id: btn.dataset.qtyChange, quantity: parseInt(btn.dataset.qty, 10) })
          });
          this.refresh();
        });
      });
    }
  };

  /* ---------- product form (AJAX add to cart) ---------- */
  function initProductForms() {
    document.querySelectorAll('form[data-ajax-cart]').forEach(form => {
      form.addEventListener('submit', async e => {
        e.preventDefault();
        const btn = form.querySelector('[type="submit"]');
        const original = btn.textContent;
        btn.textContent = 'Adding…'; btn.disabled = true;
        try {
          const res = await fetch(window.themeSettings.cartAddUrl + '.js', {
            method: 'POST', body: new FormData(form)
          });
          if (!res.ok) throw new Error((await res.json()).description || 'Could not add to cart');
          await CartDrawer.refresh();
          CartDrawer.open();
          window.confettiBurst();
          window.toast('Added — nice choice 🎉');
        } catch (err) {
          window.toast(err.message);
        } finally {
          btn.textContent = original; btn.disabled = false;
        }
      });
    });
  }

  /* ---------- quantity steppers ---------- */
  function initQtySteppers() {
    document.querySelectorAll('.qty-input').forEach(q => {
      const input = q.querySelector('input');
      q.querySelectorAll('button').forEach(b => b.addEventListener('click', () => {
        input.value = Math.max(1, parseInt(input.value || '1', 10) + (b.dataset.step === 'up' ? 1 : -1));
      }));
    });
  }

  /* ---------- variant picker ---------- */
  function initVariantPickers() {
    document.querySelectorAll('[data-variant-picker]').forEach(picker => {
      const form = picker.closest('form');
      const idInput = form.querySelector('input[name="id"]');
      const priceEl = document.querySelector('[data-product-price]');
      const comparePriceEl = document.querySelector('[data-compare-price]');
      picker.querySelectorAll('input[type="radio"]').forEach(r => {
        r.addEventListener('change', () => {
          idInput.value = r.value;
          const price = parseInt(r.dataset.price, 10);
          if (priceEl && r.dataset.price) priceEl.textContent = formatMoney(price);
          if (comparePriceEl) {
            const compareAt = parseInt(r.dataset.compareAtPrice, 10) || 0;
            if (compareAt > price) {
              comparePriceEl.textContent = formatMoney(compareAt);
              comparePriceEl.hidden = false;
            } else {
              comparePriceEl.textContent = '';
              comparePriceEl.hidden = true;
            }
          }
          const btn = form.querySelector('[type="submit"]');
          if (r.dataset.available === 'false') { btn.disabled = true; btn.textContent = 'Sold Out'; }
          else { btn.disabled = false; btn.textContent = btn.dataset.label; }
        });
      });
    });
  }

  /* ---------- media gallery ---------- */
  function initGalleries() {
    document.querySelectorAll('[data-media-gallery]').forEach(g => {
      const main = g.querySelector('[data-media-main] img');
      g.querySelectorAll('.media-thumbs button').forEach(t => {
        t.addEventListener('click', () => {
          g.querySelectorAll('.media-thumbs button').forEach(b => b.classList.remove('active'));
          t.classList.add('active');
          main.src = t.dataset.src;
          main.srcset = '';
          if (t.dataset.alt) main.alt = t.dataset.alt;
        });
      });
    });
  }

  /* ---------- product recommendations ---------- */
  function initRecommendations() {
    document.querySelectorAll('[data-recommendations]').forEach(async el => {
      try {
        const res = await fetch(el.dataset.url);
        const html = await res.text();
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const inner = doc.querySelector('[data-recommendations-results]');
        if (inner && inner.children.length) el.innerHTML = inner.innerHTML;
        else el.closest('section') && (el.closest('section').style.display = 'none');
        revealInit();
      } catch (e) { /* silently skip */ }
    });
  }

  /* ---------- nav toggle ---------- */
  function initNav() {
    const toggle = document.getElementById('navToggle');
    const nav = document.getElementById('mainNav');
    if (!toggle || !nav) return;
    toggle.addEventListener('click', () => {
      nav.classList.toggle('open');
      toggle.setAttribute('aria-expanded', nav.classList.contains('open'));
    });
  }

  /* ---------- reveal on scroll ---------- */
  let io;
  function revealInit() {
    if (!('IntersectionObserver' in window)) {
      document.querySelectorAll('.reveal').forEach(el => el.classList.add('visible'));
      return;
    }
    io = io || new IntersectionObserver(entries => {
      entries.forEach(e => { if (e.isIntersecting) { e.target.classList.add('visible'); io.unobserve(e.target); } });
    }, { threshold: 0.12 });
    document.querySelectorAll('.reveal:not(.visible)').forEach(el => io.observe(el));
  }

  document.addEventListener('DOMContentLoaded', () => {
    CartDrawer.init();
    initProductForms();
    initQtySteppers();
    initVariantPickers();
    initGalleries();
    initRecommendations();
    initNav();
    revealInit();
  });

  document.addEventListener('shopify:section:load', revealInit);
})();
